/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventaistartplaceholderlink4Inputs */

const en_eventaistartplaceholderlink4 = /** @type {(inputs: Eventaistartplaceholderlink4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste the link to the event page`)
};

const de_eventaistartplaceholderlink4 = /** @type {(inputs: Eventaistartplaceholderlink4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link zur Eventseite einfügen`)
};

/**
* | output |
* | --- |
* | "Paste the link to the event page" |
*
* @param {Eventaistartplaceholderlink4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventaistartplaceholderlink4 = /** @type {((inputs?: Eventaistartplaceholderlink4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventaistartplaceholderlink4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventaistartplaceholderlink4(inputs)
	return de_eventaistartplaceholderlink4(inputs)
});
export { eventaistartplaceholderlink4 as "eventAiStartPlaceholderLink" }